import { gql } from "@apollo/client";


export const RESET_DATABASE_QUERY = gql`
mutation ResetDatabase {
  resetDatabase
}
`;
